import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import HouseManagerApi from "@/api-client/api/services/houseManager/houseManager";

export function PopUpDeleteProject({
  trigger,
  projectId,
  fetchTenantRelationships,
}: {
  trigger: React.ReactNode;
  projectId: string;
  fetchTenantRelationships: () => void;
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDeleteProject = async () => {
    if (projectId) {
      await HouseManagerApi.deleteRepairWorks(projectId);
      fetchTenantRelationships();
      handleDialogClose(false);
    }
  };

  const handleDialogClose = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDialogClose} modal={false}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      {isOpen && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-[4px] z-40 pointer-events-none"></div>
      )}
      <DialogContent className="max-h-full overflow-auto w-[440px] pb-[40px]">
        <DialogHeader className="mb-[16px]">
          <DialogTitle className="text-[24px] font-medium flex items-center justify-center gap-4">
            <div className="border-[3px] border-[#FF0000] text-[#FF0000] rounded-full w-[48px] h-[48px] flex items-center justify-center">
              !
            </div>
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 mb-4">
          <span className="text-[24px] font-medium text-center">
            {t("PopUpDeleteProject.delete_project")}
          </span>

          <span className="text-[18px] font-medium text-[#00000080] text-center">
            {t("PopUpDeleteProject.delete_project_description")}
          </span>
        </div>

        <Button
          type="submit"
          variant="system"
          size="system"
          disabled={false}
          loading={false}
          onClick={handleDeleteProject}
        >
          {t("PopUpDeleteProject.delete_project")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
